import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { auth } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("kd_token");
    if (!token) {
      setReady(true);
      return;
    }
    auth.me().then(setUser).catch(() => localStorage.removeItem("kd_token")).finally(() => setReady(true));
  }, []);

  const login = useCallback(async (email, password) => {
    const { token, user } = await auth.login({ email, password });
    localStorage.setItem("kd_token", token);
    setUser(user);
    return user;
  }, []);

  const register = useCallback(async (payload) => {
    const { token, user } = await auth.register(payload);
    localStorage.setItem("kd_token", token);
    setUser(user);
    return user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("kd_token");
    setUser(null);
  }, []);

  return (
    <AuthCtx.Provider value={{ user, login, register, logout, ready }}>{children}</AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
